/* eslint-disable no-param-reassign */
/* eslint-disable no-mixed-operators */
import React, { useState, useRef, useEffect } from 'react'
import { useReactToPrint } from 'react-to-print'
import moment from 'moment'
import request from 'meinian-package/src/utils/request'
import { ELE_TYPE, STYLE_TYPE_TEXT, STYLE_PLAN_TEXT } from 'common/config/enum'
import { SAMPLE_STATE_DATA } from 'component/waterfall.card/sampleCardExamine/common'
import { sampleSourceData, sampleTypeData, sampleSeasonData } from '../filter/sampleFilterOptions'
import Note from './note'
import './index.less'

/**
 * @description: 由于卡片更多选项支持打印，故重新封装打印组件
 * @return {*}
 */

const DYNAMICS_VALUE = {
  STYLE: 1,
  SAMPLE: 2
}
// 定义表格的表头
const COLUMNS_TEXT = ['批注序号', '批注内容', '批注人', '批注时间']
// 款式属性的文字
const PROPER_TEXT = ['品类', '年份季节', '款式类型', '开款计划', '主推风格', '主推面料', '主推辅料', '关联款式']

export default (props) => {
  const { children, blogId, sampleId, collectId, upgradeInfo = {}, imageInfo } = props
  const $content = useRef()

  // 打印事件（控制dom的显示）
  const onPrint = useReactToPrint({
    content: () => $content.current,
  })

  return <>
    <span onClick={onPrint}>{children || '打印图片'}</span>
    <PrintContent $content={$content} blogId={blogId} sampleId={sampleId} collectId={collectId} upgradeInfo={upgradeInfo} imageInfo={imageInfo} />
  </>
}

const PrintContent = ({ $content, blogId, sampleId, collectId, upgradeInfo = {}, imageInfo }) => {
  const [sampleData, setSampleData] = useState([])
  const [loading, setLoading] = useState(false)
  const [notes, setNotes] = useState([])
  const [tags, setTags] = useState([])
  const [dynamics, setDynamics] = useState([])
  const [sampleTag, setSampleTag] = useState()

  useEffect(() => {
    if (!sampleId && !blogId) return
    init()
  }, [sampleId, blogId, JSON.stringify(imageInfo)])

  const init = async () => {
    (async () => {
      setLoading(true)
      if (sampleId) {
        const res = await request.get('/zhikuan/mn/sample/query-sample-detail', { params: { sampleId } })
        setSampleData(res)
        fetchNotes(res?.imgUrlList?.[0])
        fetchDynamic(DYNAMICS_VALUE.SAMPLE, sampleId)
        fetchSampleTag(res || {})
      } else {
        if (imageInfo?.length > 0) {
          fetchNotes(imageInfo?.[0])
          fetchDynamic(DYNAMICS_VALUE.STYLE, imageInfo?.[0]?.collectId)
        }
        fetchTag()
      }
      setLoading(false)
    })()
  }
  const fetchTag = async () => {
    const _tags = await request.get(`/zhikuan/img-tag/list-img-tag?entityId=${blogId}`)
    setTags(_tags || [])
  }
  const fetchSampleTag = async (detail) => {
    const res = await request.get('/zhikuan/img-tag/list-img-tag', { params: { entityId: detail.blogId } })
    setSampleTag(res)
  }
  // 图片标注点位置计算
  const getGeometric = (resNotes, currentImgInfo) => {
    const imgSize = currentImgInfo
    if (imgSize.height / imgSize.width > 465 / 400) {
      const imgWidth = 465 / (imgSize.height / imgSize.width)
      const leftWidth = (400 - imgWidth) / 2
      resNotes.forEach((item) => {
        item.xmin = item.xmin * imgWidth + leftWidth
        item.ymin *= 465
        item.xmax = item.xmax * imgWidth + leftWidth
        item.ymax *= 465
      })
    } else {
      const imgHeight = 400 / (imgSize.height / imgSize.width)
      const topHeight = (465 - imgHeight) / 2
      resNotes.forEach((item) => {
        item.xmin *= 400
        item.ymin = item.ymin * imgHeight + topHeight
        item.xmax *= 400
        item.ymax = item.ymax * imgHeight + topHeight
      })
    }
    setNotes(resNotes.reverse())
  }

  // 获取标注点坐标
  const fetchNotes = async (currentImgInfo) => {
    let params
    setLoading(true)
    if (sampleId) {
      params = {
        entityId: sampleId,
        inspirationId: sampleId,
        mainUrl: currentImgInfo.mainUrl,
        type: 1,
        targetId: collectId
      }
    } else {
      params = {
        entityId: currentImgInfo?.imageGroupEntityId,
        inspirationId: currentImgInfo?.inspirationId,
        mainUrl: currentImgInfo?.mainUrl,
        targetId: currentImgInfo.collectId
      }
    }
    if (!currentImgInfo?.mainUrl || (!currentImgInfo.collectId && !collectId)) return
    try {
      const res = await request.post('/zhikuan/annotation/get-inspiration-blog-annotation', params)
      if (res.baseBlogAnnotationDTOList) {
        getGeometric(res.baseBlogAnnotationDTOList, currentImgInfo)
      }
    } catch (err) {
      console.error(err)
    }
    setLoading(false)
  }
  // 获取动态信息
  const fetchDynamic = async (type, id) => {
    if (!id) return
    try {
      const res = await request.get('/zhikuan/mn/dynamic/query-operation-dynamic-info', { params: { targetType: type, targetId: id } })
      if (res) {
        setDynamics(res)
      }
    } catch (err) {
      console.error(err)
    }
  }

  return <div ref={$content} className="meinian-print-image-box">
    <div>
      <div className="meinian-print-image-content">
        <div className="main-image-wrapper">
          <img src={imageInfo?.[0]?.mainUrl || sampleData?.imgUrlList?.[0]?.mainUrl} className="main-image" />
          {notes?.length > 0 ? notes.map((item, index) => {
            return <Note data={item} index={index + 1} />
          }) : null}
        </div>
        {sampleData ? <Element sampleData={sampleData} /> : null}
        {imageInfo?.length > 0 ? <Element imageInfo={imageInfo[0]} /> : null}
      </div>
      <div className="meinian-print-table-content">
        {!loading ? <OriginTable columsdata={COLUMNS_TEXT} dataSource={notes} /> : null}
      </div>
      <div className="page-break" />
    </div>
    <div>
      <div className="meinian-print-title-content">
        <StyleTitle title={sampleId ? '样衣' : '款式'} name={upgradeInfo && upgradeInfo.styleTitle || sampleData?.name} tags={tags || sampleTag} />
      </div>
      <div className="meinian-print-style-proper">
        {sampleId ? <SampleStyle {...sampleData} /> : <StyleProper properTitles={PROPER_TEXT} properInfo={upgradeInfo} properName="款式属性" />}
      </div>
      <div className="meinian-print-style-dynamic">
        {dynamics && dynamics.length > 0 ? <StyleProper properName={`${sampleId ? '样衣' : '款式'}动态`} dynamics={dynamics} /> : null}
      </div>
      <div className="page-break" />
    </div>
    <div className="meinian-print-style-images">
      <div className="title">{`${sampleId ? '样衣' : '款式'}图库`}</div>
      <div className="meinian-print-images-wrapper">
        {(imageInfo?.length > 0 ? imageInfo : sampleData.imgUrlList)?.map((image, index) => <>
          <img src={image.mainUrl} alt="" style={{ width: 390, height: 510, marginBottom: 20, marginRight: index % 2 ? 0 : 20, objectFit: 'contain' }} />
          {index % 4 === 3 ? <div className="page-break" /> : null}
        </>)}
      </div>
    </div>
  </div>
}

const Element = ({ imageInfo, sampleData }) => {
  let elements
  if (imageInfo) {
    elements = imageInfo?.boxLabelRetList?.[0] || {}
  } else {
    elements = sampleData
  }
  const {
    colorList, style, texture, technology, rootFabric, fabric,
    accessories, contour, collar, vamp, element, process, sole, category, color
  } = elements
  const finalElements = { texture, technology, fabric, accessories, contour, collar, vamp, element, process, sole }
  const hasElements = texture || technology || rootFabric || fabric || accessories || vamp || element || process || sole
  const show = (colorList || []).length || style || hasElements

  if (!show) return null
  return <div className="element">
    <div className="title">智能标签</div>
    <div className="elements">
      {sampleData ? <ul>
        <DisplayText name="品类" value={[category]} />
        {(color) ? <li className="element-item">
          <span className="item-key">{ELE_TYPE.colorList}</span>
          <div className="item-value-wrapper">{color}</div>
        </li> : null}
        {style ? <li className="element-item">
          <span className="item-key">{ELE_TYPE.style}</span>
          <div className="item-value-wrapper">{style}</div>
        </li> : null}
        {
          Object.keys(finalElements).filter(m => finalElements[m]).map((ele) => {
            return <div>
              {ele ? <li className="element-item">
                <span className="item-key">{ELE_TYPE[ele]}</span>
                <div className="item-value-wrapper">{sampleData[ele]}</div>
              </li> : null}
            </div>
          })
        }
      </ul> : <ul>
        <DisplayText name="品类" value={[category]} />
        {(colorList && colorList.length) ? <li className="element-item">
          <span className="item-key">{ELE_TYPE.colorList}</span>
          <div className="item-value-wrapper">
            {colorList.map(value => <>{value.tag}&nbsp;</>)}
          </div>
        </li> : null}
        {style ? <DisplayText
          name={ELE_TYPE.style}
          value={style.map(n => n.tag)}
        /> : null}
        {
          Object.keys(finalElements).filter(m => finalElements[m]).map((ele) => {
            if (ele === 'technology' || ele === 'accessories' || ele === 'sole') {
              return finalElements[ele].map(e => <DisplayText name={e.rootTag} value={[e.tag]} />)
            }
            return <DisplayText name={ELE_TYPE[ele]} value={finalElements[ele].map(n => n.tag)} />
          })
        }
      </ul>}
    </div>
  </div>
}
const DisplayText = ({ name, value = [] }) => {
  return (
    <li className="element-item" style={{ justifyContent: 'normal' }}>
      <span className="item-key">{name}</span>
      <span className="item-value-wrapper">
        {value.length ? value.map(m => m.split(',').map(n => <>{n}&nbsp;</>)) : null}
      </span>
    </li>)
}
// 标注的表格
const OriginTable = ({ columsdata, dataSource }) => {
  const show = dataSource.length > 0
  if (!show) return null
  return (
    <table>
      <tr>
        {columsdata.map((item) => {
          return <th>{item}</th>
        })}
      </tr>
      {dataSource.map((item, index) => {
        return <tr>
          <td style={{ width: '88px' }}>{index + 1}</td>
          <td style={{ width: '354px' }}>{item.annotationContent}</td>
          <td style={{ width: '136px' }}>{item.userName.substr(0, 8)}</td>
          <td>{moment(item.updatedAt).format('YYYY/MM/DD HH:mm')}</td>
        </tr>
      })}
    </table>
  )
}
// 款式标题
const StyleTitle = ({ name, tags, title }) => {
  const show = name !== '' || (tags || []).length
  if (!show) return null
  return <>
    <div className="title">{`${title}标题`}</div>
    <div className="style-name">{name}</div>
    <div className="labels">
      <span>标签</span>
      {tags && tags.length > 0 ? tags.map((item) => {
        return <span className="tag">{item.tagName}</span>
      }) : null}
    </div>
  </>
}
// 款式属性、款式动态
const StyleProper = ({ properTitles, properInfo, properName, dynamics }) => {
  return <div>
    {properTitles ? <div>
      {properInfo ? <>
        <div className="title">{properName}</div>
        <div className="proper-info">
          <ul>
            <StyleItem label="品类" value={`${properInfo.gender || ''}${properInfo.category ? `-${properInfo.category}` : ''}`} />
            <StyleItem label="年份季节" value={properInfo.season} />
            <StyleItem label="开款计划" value={STYLE_PLAN_TEXT[properInfo.stylePlan]} />
            <StyleItem label="款式类型" value={STYLE_TYPE_TEXT[properInfo.styleType]} />
            <StyleItem label="主推风格" value={properInfo.style} />
            <StyleItem label="主推面料" value={properInfo.fabric} />
            <StyleItem label="主推辅料" value={properInfo.accessories} />
            <StyleItem label="关联款式" value={properInfo.relatedInspirationUrl} />
          </ul>
        </div>
      </> : null}
    </div> : <>
      <div className="title">{properName}</div>
      <div className="proper-info">
        <ul>
          {dynamics.map((item) => {
            return <li className="info-item" key={item.inspirationId}>
              <span className="item-key">{item.operationDesc}</span>
              <div className="item-value"><span>{item.operationName}</span><span style={{ marginLeft: '20px' }}>{item.operationTime}</span></div>
            </li>
          })}
        </ul>
      </div>
    </>}
  </div>
}

// 样衣属性
const SampleStyle = (props) => {
  const { sampleCode, source, type, state, num, price, gender, category, season, color, size, style, fabric, accessories } = props
  return <>
    <div className="title">样衣属性</div>
    <div className="proper-info">
      <ul>
        <StyleItem label="样衣ID" value={sampleCode} />
        <StyleItem label="样衣来源" value={source ? sampleSourceData.find(m => source == m.value).label : ''} />
        <StyleItem label="样衣类型" value={type ? sampleTypeData.find(m => type == m.value).label : ''} />
        <StyleItem label="样衣状态" value={state ? SAMPLE_STATE_DATA.find(m => state == m.value).label : ''} />
        <StyleItem label="样衣价格" value={price ? `${price} ¥` : ''} />
        <StyleItem label="样衣数量" value={num} />
        <StyleItem label="样衣品类" value={gender + (category ? '-' : '') + category} />
        <StyleItem label="样衣季节" value={season ? sampleSeasonData.find(m => season == m.value).label : ''} />
        <StyleItem label="样衣颜色" value={color} />
        <StyleItem label="样衣尺码" value={size} />
        <StyleItem label="主推风格" value={style} />
        <StyleItem label="主推面料" value={fabric} />
        <StyleItem label="主推辅料" value={accessories} />
      </ul>
    </div>
  </>
}

const StyleItem = (props) => {
  const { label, value } = props
  return <li className="info-item">
    <span className="item-key">{label}</span>
    <div className="item-value"><span>{value}</span></div>
  </li>
}
